/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import './src/styles/global.css'
import './src/styles/masonry-fix.css'

// Import Space Grotesk font
import '@fontsource/space-grotesk/400.css'
import '@fontsource/space-grotesk/500.css'
import '@fontsource/space-grotesk/700.css'

import React from "react"
import Root from "./src/components/Root"
import { SiteDataProvider } from "./src/context/SiteDataContext"

export const wrapRootElement = ({ element }) => {
  return (
    <SiteDataProvider>
      <Root>{element}</Root>
    </SiteDataProvider>
  )
}